export function isNonNulled<T>(value: T): value is NonNullable<T> {
  return value != null;
}
